export default "__VITE_ASSET__da50dd86__"